import {useNavigate, useParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {createPortal} from "react-dom";
import {Card, CardContent} from "@mui/material";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import Grid from "@mui/material/Grid";
import {getPublicWaiver, submitPublicWaiver} from "../common/api/PortalCustomerApi";
import {CONSTANTS} from "../common/constants";
import {CompanyContext} from "../../lib/CompanyProvider";
import {UserContext} from "../../lib/UserProvider";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import {MenuContext} from "../../lib/MenuProvider";
import Meta from "../common/Meta";
import EsignatureField from "./waiver/EsignatureField";

export default function CustomerWaiver(props) {

  let {guid} = useParams();

  const [context, setContext] = useContext(AppContext);
  const [menuContext, setMenuContext] = useContext(MenuContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [company, setCompany] = useState(companyContext?.company);

  const [waiverReady, setWaiverReady] = useState(false);
  const [waiver, setWaiver] = useState();
  const [waiverBody, setWaiverBody] = useState();
  const [formattedWaiverBody, setFormattedWaiverBody] = useState();
  const [pageReady, setPageReady] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (userContext.sessionUser?.userTypeId) {
      let showLogin = !userContext?.sessionUser?.guid?.length > 0;
      setUserContext({...userContext, showLogin: showLogin, loginNag: true});
      setPageReady(!showLogin);
    }
  }, [userContext?.sessionUser]);

  useEffect(() => {
    if (companyContext?.company?.guid) {
      setCompany(companyContext?.company);
    }
  }, [companyContext?.company]);

  useEffect(() => {
    if (!pageReady) {
      return;
    }

    if (guid) {
      setWaiverReady(false);
      getPublicWaiver(guid).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setWaiver(result);
          setWaiverBody(result.waiverBody);
          setWaiverReady(true);
        }
      });
    }
  }, [pageReady, guid]);

  const handleClose = () => {
    // setShowMembershipModal(false);
  }
  const handleSave = (data) => {
    //  setSavingMembership(true);
  }

  const formContainerRef = useRef(null);
  const esigRefs = useRef({});
  const [esigMounts, setEsigMounts] = useState([]);

  useEffect(() => {
    const container = formContainerRef.current;
    if (!container) {
      setEsigMounts([]);
      return;
    }
    const nodes = Array.from(container.querySelectorAll('[data-esig-mount]'));
    esigRefs.current = {};
    setEsigMounts(nodes.map((node) => ({
      name: node.dataset.esigMount,
      required: node.dataset.esigRequired === '1',
      node,
    })));
  }, [waiverBody]);

  const handleWaiverSubmit = async (e) => {

    for (const mount of esigMounts) {
      const field = esigRefs.current[mount.name];
      if (mount.required && field?.isEmpty()) {
        field.showError();
        setContext({...context, error: {message: 'Please provide your signature before submitting.'}});
        return;
      }
    }

    const formData = {};
    const form = document.getElementById('waiverForm');

    const elements = form.elements;
    for (let j in elements) {
      if (!elements[j].className?.match('replacement')) {
        continue;
      }
      if (!elements[j].value) {
        continue;
      }
      formData[elements[j].name] = elements[j].value;
    }

    const saveData = {
      waiver: waiver,
      formData: formData
    }

    submitPublicWaiver(saveData).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {

        setUserContext({...userContext, refreshIdentity: true})

        let _c = {...context};
        _c.toast = {message: 'Waiver submitted successfully'};
        setContext({..._c});
        setMenuContext({...menuContext, refreshContext: true});

        setTimeout(() => {
          setContext({...context, toast: {}});
        }, CONSTANTS.TOAST_TIMEOUT);
        navigate('/cx/waivers');
      }

    });

  }

  const formatReplacements = (html, replacement, placeholder, type) => {
    let _html = html;
    const pattern = '{' + replacement + '}';

    const regex = new RegExp(pattern, 'g');

    let matches = _html.match(regex);

    if (!matches) {
      return _html;
    }

    matches.forEach((item, index) => {
      let defaultValue = replacement.match('checkbox') ? 'Yes' : '';
      let isRequired = true;
      if (item.match('conditional')) {
        isRequired = false;
      }
      if ('esignature' === type) {
        _html = _html.replace(item, '<div class="esignature-mount" data-esig-mount="' + replacement + '-' + index
          + '" data-esig-required="' + (isRequired ? '1' : '0') + '"></div>');
      } else if ('textarea' === type) {
        _html = _html.replace(item, '<textarea required value="' + defaultValue + '" placeholder="'
          + placeholder + '" type="' + type + '" name="' + replacement + '-' + index + '" class="replacement d-block w-100" rows="4"></textarea>');
      } else {
        if (isRequired) {
          _html = _html.replace(item, '<input required value="' + defaultValue + '" placeholder="'
            + placeholder + '" type="' + type + '" name="' + replacement + '-' + index + '" class="replacement" />');
        } else {
          _html = _html.replace(item, '<input onchange="this.value = this.checked ? \'Yes\' : \'No\';" value="No" placeholder="'
            + placeholder + '" type="' + type + '" name="' + replacement + '-' + index + '" class="replacement" />');
        }
      }
    });


    return _html;
  }

  const formItems = [
    {icon: "person", label: "First Name", replacement: "firstName", type: "input"},
    {icon: "person", label: "Last Name", replacement: "lastName", type: "input"},
    {icon: "person", label: "Full Name", replacement: "fullName", type: "input"},
    {icon: "person", label: "Parent / Guardian Name", replacement: "legal-name", type: "input"},
    {icon: "person_add", label: "Child", replacement: "child-name", type: "input"},
    {icon: "check_box", label: "Agree", replacement: "checkbox-agree", type: "checkbox"},
    {icon: "check_box_outline_blank", label: "Opt-In", replacement: "checkbox-conditional", type: "checkbox"},
    {icon: "app_registration", label: "E-Signature", replacement: "e-signature", type: "esignature"},
    {icon: "notes", label: "Answer", replacement: "answer", type: "input"},
    {icon: "edit", label: "Signature", replacement: "signature", type: "text"},
    {icon: "event_note", label: "Comment", replacement: "message", type: "textarea"},
    {icon: "event", label: "Date", replacement: "date", type: "date"},
  ];

  const formatPlaceholders = (html, replacement, placeholder, type) => {
    let _html = html;
    const pattern = '{' + replacement + '}';

    const regex = new RegExp(pattern, 'g');

    let matches = _html.match(regex);

    matches.forEach((item, index) => {
      _html = _html.replace(item, '{' + replacement + '-' + index + '}');
    });

    return _html;
  }

  const toForm = (html) => {
    let _html = html;
    for (let j in formItems) {
      let item = formItems[j];
      _html = formatReplacements(_html, item.replacement, item.label, item.type);
    }
    return _html;
  }

  return (
    <>
      <CustomerPageLayout>
        <Meta pageTitle={'Waiver'}/>
        <CustomerHeader props={props}/>

        {waiverReady && <MDBox p={3}>
          <MDBox m={3}>

            <Grid container cols={3} spacing={3} direction="row">
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent>
                    <MDTypography variant="h5" color="secondary" fontWeight="light">
                      Assigned Waiver - {waiver?.waiverName}
                    </MDTypography>
                    <MDBox mt={3}>
                      {waiverBody && <form id="waiverForm" onSubmit={(e) => {
                        e.preventDefault();
                        handleWaiverSubmit(e);
                      }}>
                        <span
                          ref={formContainerRef}
                          dangerouslySetInnerHTML={{__html: toForm(waiverBody)}}></span>
                        {esigMounts.map((mount) => createPortal(
                          <EsignatureField
                            key={mount.name}
                            name={mount.name}
                            required={mount.required}
                            ref={(inst) => {
                              if (inst) {
                                esigRefs.current[mount.name] = inst;
                              } else {
                                delete esigRefs.current[mount.name];
                              }
                            }}
                          />,
                          mount.node
                        ))}
                        <div className="row">
                          <div className="col col-12">
                            <MDButton type="submit" color="info">
                              Save
                            </MDButton>
                          </div>
                        </div>
                      </form>}
                      <hr/>
                      {formattedWaiverBody && <div dangerouslySetInnerHTML={{__html: formattedWaiverBody}}></div>}
                    </MDBox>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        }

        <Footer/>
      </CustomerPageLayout>
    </>
  )
}
